import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import { getBottomAxisLayout } from './axisLayout';
import { useChartTheme } from './useChartTheme';
import './charts.css';

const DEFAULT_COLORS = ['#2563eb'];
const DEFAULT_MARGIN = { top: 24, right: 24, bottom: 70, left: 80 };

export default function LineChart({
  data,
  colors,
  height = 300,
  title,
  valueFormatter,
  tooltipFormatter,
  xLabel,
  yLabel,
  tickRotation = -45,
  showGrid = true,
  margin = DEFAULT_MARGIN,
}) {
  // Ensure data is an array and colors is not null
  const chartData = React.useMemo(() => data || [], [data]);
  const chartColors = colors || DEFAULT_COLORS;
  const formatValue = valueFormatter || ((value) => new Intl.NumberFormat('en-US').format(Number(value) || 0));
  const theme = useChartTheme();

  const axisBottomLayout = React.useMemo(() => {
    return getBottomAxisLayout({
      labels: chartData.map((d) => d.x),
      tickRotation,
      margin,
      hasLegend: Boolean(xLabel),
    });
  }, [chartData, tickRotation, margin, xLabel]);
  const effectiveMargin = axisBottomLayout.margin;

  // Ensure the chart container is tall enough to keep at least 150px of plot area.
  const effectiveHeight = Math.max(height, effectiveMargin.top + effectiveMargin.bottom + 150);


  return (
    <div className="chart-card">
      {title && <div className="chart-title">{title}</div>}
      <div className="chart-plot" style={{ height: effectiveHeight }}>
        <ResponsiveLine
          data={[{ id: 'series', data: chartData.filter((d) => d.y != null).map((d) => ({ x: d.x, y: d.y })) }]}
          theme={theme}
          colors={chartColors}
          margin={effectiveMargin}
          xScale={{ type: 'point' }}
          yScale={{ type: 'linear', stacked: false, min: 'auto', max: 'auto' }}
          lineWidth={3}
          curve="monotoneX"
          areaOpacity={0.08}
          pointColor="#5B8CFF"
          pointBorderWidth={2}
          pointBorderColor="var(--surface-1)"
          pointSize={8}
          enableCrosshair
          axisBottom={{
            tickRotation,
            legend: xLabel,
            legendOffset: axisBottomLayout.legendOffset,
            legendPosition: 'middle',
            tickSize: 5,
            tickPadding: 5,
            truncateTickAt: 0,
          }}
          axisLeft={{
            legend: yLabel,
            legendOffset: -72,
            legendPosition: 'middle',
            format: formatValue,
          }}
          enableGridX={false}
          enableGridY={showGrid}
          yFormat={formatValue}
          useMesh
          
        />
      </div>
    </div>
  );
}
